<template>
  <div :class="{ 'airports': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>Airports</legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add airports after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading airports.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          theme="success"
          @click.prevent="addAirport"
          outline
          class="ml-auto">
          Add airport
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>ICAO</th>
              <th>IATA</th>
              <th>Warnings</th>
              <th>Preferred</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <airports-list-item
              v-for="(airportData, index) of airports"
              :key="'airports-list-item-' + index"
              :referenceId="referenceId"
              :airportData="airportData" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && airports.length === 0"
        theme="light"
        show
        class="text-center">
        There are no airports for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import AirportsListItem from './AirportsListItem.vue';

export default {
  name: 'airports-list',
  components: {
    'airports-list-item': AirportsListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      airports: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadAirports();
    }

    this.$bus.$on('airports-list-reload', this.reload);
  },
  methods: {
    loadAirports () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/airports/items',
        params: {
          pagination: 0,
          where: {
            handler_id: this.referenceId
          }
        },
        loadedKey: 'loaded',
        outputKey: 'airports',
        errorKey: 'loadError'
      });
    },
    addAirport () {
      this.$bus.$emit('show-airport-popup', this.referenceId);
    },
    reload () {
      this.loaded = false;
      this.loadAirports();
    }
  },
  beforeDestroy () {
    this.$bus.$off('airports-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.airports {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
